export default "__VITE_ASSET__55b7f903__"